import { render } from "./Ticket_Attachment_Picker.vue?vue&type=template&id=0ec19936"
import script from "./Ticket_Attachment_Picker.vue?vue&type=script&lang=js"
export * from "./Ticket_Attachment_Picker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__